export const QUERY_KEYS = {
  allEvents: () => ['calendarEvents'],
  singleEvent: (eventId: string) => [...QUERY_KEYS.allEvents(), eventId],
};
